export const ProspectActivityActionTypeId = {
  requestedAppraisal: 1,
  propertyEstimate: 2,
  propertyListed: 3,
  prospectCreated: 4,
  sent: 5,
  leadcaptured: 6,
  oaMatch: 7,
  addAddress: 8,
  OAProspect: 9,
  PastAppraisal: 10,
  DomainProspect: 11,
  DomainMatch: 12,
  CallAttempt: 13,
  CallContact: 14,
  CallSuccess: 15,

  timeframeAndRelationship: 0, // This is manually added in the FE
};

export const ProspectPropertyRelationshipId = {
  ownerOccupier: 1,
  ownerInvestor: 3,
  buyer: 2,
  tenant: 4,
};

export const ProspectSellingTimeframeId = {
  within3Months: 1,
  '3to6Months': 2,
  '6to12Months': 3,
  '12to24Months': 4,
  notSelling: 5,
  alreadyOnMarket: 6,
  IDontKnow: 7,
  immediately: 8
};

export const ProspectReminderTypeId = {
  followUp: 1,
  bookedAppraisal: 2,
};

export const OaLeadSourceTypeId = {
  propertyReports: 6,
  smartSearch: 59,
  openEstimates: 62,
  poweredBy: 74,
};

export const ProspectActivityActorTypeId = {
  contact: 1,
  oaConsultant: 5,
};
